import React from "react";

const Mail = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none" {...props}>
    <path d="M12.5 12.5H60.5C63.8 12.5 66.5 15.2 66.5 18.5V54.5C66.5 57.8 63.8 60.5 60.5 60.5H12.5C9.2 60.5 6.5 57.8 6.5 54.5V18.5C6.5 15.2 9.2 12.5 12.5 12.5Z" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M66.5 18.5L36.5 39.5L6.5 18.5" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default Mail;